// extracted by mini-css-extract-plugin
export default {"btnIcon":"Button_btnIcon__+Z-X9"};